import { useState, useEffect } from 'react';

export function useIsScrolled(threshold = 50): boolean {
    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => {
            setIsScrolled(window.scrollY > threshold);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll(); // проверить сразу при монтировании
        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, [threshold]);
    return isScrolled;
}
